// Hooks for the public marketing site (homepage, demo booking). They're prefixed with
// `Marketing` so they never collide with the app's hooks.
import AutosendTimerHooks from './autosend_timer';
import CalEmbedHooks from './cal_embed';
import PreviewTourHooks from './preview_tour';
import TestimonialRotateHooks from './testimonial_rotate';

const MarketingHooks = {
  ...AutosendTimerHooks,
  ...CalEmbedHooks,
  ...PreviewTourHooks,
  ...TestimonialRotateHooks,
};

export default MarketingHooks;
